import BaseRepositoryClass from 'api/utils/BaseRepositoryClass';
import { RepositoryType, } from 'api/utils/RepositoryTypes';

export interface OrderType {
    orderNumber: number,
    pdf: string
}

class OrderRepository extends BaseRepositoryClass implements RepositoryType {
    get(token: string) {
        return this
            .requester
            .get<OrderType>(`order/${token}`);
    }
}

export default OrderRepository;
